import Entity, { IEntity } from '../abstract/Entity';

export interface ICompass extends IEntity {
  rotation: number;
}

class CompassModel extends Entity implements ICompass {
  rotation: number;

  constructor(rotation: number = 0) {
    super();
    this.rotation = this.normalizeAngle(rotation);
  }

  getRotation(): number {
    return this.rotation;
  }

  setRotation(rotation: number): void {
    this.rotation = this.normalizeAngle(rotation);
  }

  normalizeAngle(angle: number): number {
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return Math.round(angle);
  }

  toJSON() {
    return {
      ...super.toJSON(),
      rotation: this.rotation,
    };
  }
}

export default CompassModel;
